const sanitizeScopeKey = (scope: string) => scope.replace(/:/g, '_') // remove ':' as it's interpreted by i18n

export { sanitizeScopeKey }
